<template>
  <div class="password">
    <div class="password-title">パスワード再設定</div>
    <!-- <div class="password-subtitle">
      「<a href = "/terms.html" target="_blank">利用規約</a>」
      「<a href = "https://www.tkhs.co.jp/about/privacy.html" target="_blank">個人情報の取り扱いについて</a>」
      <span>に同意の上ご利用ください。</span>
    </div> -->
    <el-form ref="resetPasswordForm" :model="form" class="app-form" :rules="rules">
      <el-form-item label="新しいパスワード" prop="newPassword">
        <el-input type="password" v-model="form.newPassword" autocomplete="off"
          placeholder="半角英数字大文字小文字含む8桁" maxlength="8"
        ></el-input>
      </el-form-item>
      <el-form-item label="新しいパスワード(再入力)" prop="newPasswordConfirm">
        <el-input type="password" v-model="form.newPasswordConfirm" autocomplete="off"
          placeholder="半角英数字大文字小文字含む8桁" maxlength="8"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="studypack-button-primary" type="primary" @click="onSubmit">変更</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';
import Cookies from 'js-cookie';
import { Notification } from 'element-ui';

export default {
  data() {
    return {
      form: {
        newPassword: '',
        newPasswordConfirm: '',
      },
      rules: {
        newPassword: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8}$/, message: '半角英数字大文字小文字含む8桁で入力してください。', trigger: 'blur' },
        ],
        newPasswordConfirm: [
          { required: true, message: '必須です。', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPassword) {
                callback(new Error('新しいパスワードと一致しません。'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      const { reset_password_token: resetPasswordToken } = this.$route.query;
      const { manshon_id: manshonIdUrl } = this.$route.query;
      console.log('###>トークン無効対応');
      console.log(this.$route.query);
      console.log(resetPasswordToken);
      console.log(manshonIdUrl);

      this.$refs.resetPasswordForm.validate((valid) => {
        if (valid) {
          Cookies.remove('token');
          request('resetPassword', {
            password: this.form.newPassword,
            token: resetPasswordToken,
          }).then(() => {
            Notification({
              title: '成功',
              message: 'パスワード再設定が成功しました。',
              // duration: 0,
              offset: 75,
              type: 'success',
            });
            this.$router.push({
              path: '/login',
              query: { manshonId: manshonIdUrl },
            }).catch(() => {});
          });
          return true;
        }
        console.log('error submit!!');
        return false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.password {
  margin: 40px auto;
  max-width: 600px;

  .password-title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 24px;
  }
  .password-subtitle {
    text-align: center;
    font-size: 18px;
    margin-bottom: 24px;
  }
  .password-docs {
    font-size: 16px;
    margin-bottom: 24px;
    line-height: 1.2;
  }
}
</style>
